/**
 *
 * Asynchronously loads the component for EmailNotifications
 *
 */

import { lazyLoad } from 'utils/loadable';

export const EmailNotificationsPage = lazyLoad(
  () => import('./index'),
  module => module.EmailNotificationsPage,
);
